import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
import {
	GET_LOCATIONS,
	GET_TOP_DESTINIES,
} from "../../store/destinies/getter-types";
import Axios from "axios";
import { mapGetters } from "vuex";

export default {
	props: {
		title: {
			type: String,
			required: false,
		},
		subtitle: {
			type: String,
			required: false,
		},
		btnLabel: {
			type: String,
			required: false,
		},
	},
	computed: {
		...mapGetters({
			destinies: GET_TOP_DESTINIES,
		}),
	},
	methods: {
		navigateToDestinies() {
			this.$router.push({ name: "destinies" });
		},
	},
};
